import React from 'react'
import {connect} from 'react-redux'
import {Alert, Button, Card, Col, Divider, message, Progress, Row, Spin, Table, Typography} from 'antd'
import {withRouter} from 'react-router-dom'
import '../../asset/less/NewPieces.css'
import {FileSyncOutlined, FileTextFilled, InboxOutlined, QuestionCircleOutlined} from '@ant-design/icons'
import Dragger from 'antd/es/upload/Dragger'
import Meta from 'antd/es/card/Meta'
import {uploadImage} from '../../api/amazonS3'
import {patchArtwork, postArtwork, postArtworkAdmin} from '../../api/artworks'
import {patchArtworkConfig, postArtworkConfig} from '../../api/artworkConfigs'
import {ExcelRenderer} from 'react-excel-renderer'
import moment from 'moment'
import HttpError from '../../component/base/HttpError'
import Modal from 'antd/es/modal/Modal'
import Sheets from '../../asset/file/revart_artwork_sheets_template_23_01_03.xlsx'
import {URL_EDIT_PIECES_ID, URL_FAQS, URL_PIECES} from '../../const'
import {getEditUrl} from '../../component/Utils'
import {is_admin_user} from "../../app/role";

const {Title} = Typography

@connect((state) => ({
    userId: state.user.info.id,
    artistId: state.user.info.artistId, // artist obj id
    email: state.user.info.email,
    role: state.user.info.role
}))
class NewBulkUpload extends React.Component {
    constructor(props) {
        super(props)
        this.expoFormRef = React.createRef()
        this.state = {
            loading: false,
            updateBtnEnabled: false,
            confirmBtnEnabled: false,
            fileList: [],
            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            artistId: this.props.artistId,
            role: this.props.role,
            selectNameId: [],
            dataSource: [],
            rows: [],
            cols: [],
            promiseResults: [],
            successPromiseNum: 0,
            totalPromiseNum: 0,
            progressVisible: false,
            templateType: 0
        }
    }

    Change = (info) => {
        if (info.file.status === 'done') {
            this.setState({
                confirmBtnEnabled: true,
                loading: false
            })
            message.success(`${info.file.name} file uploaded successfully`).then((r) => {
            })
        } else if (info.file.status === 'error') {
            this.setState({
                confirmBtnEnabled: false,
                loading: false
            })
            message.error(`${info.file.name} file upload failed.`).then((r) => {
            })
        }
    }
    onChange = (info) => {
        if (info.file.status === 'done') {
            this.setState({
                updateBtnEnabled: true,
                loading: false
            })
            message.success(`${info.file.name} file uploaded successfully`).then((r) => {
            })
        } else if (info.file.status === 'error') {
            this.setState({
                updateBtnEnabled: false,
                loading: false
            })
            message.error(`${info.file.name} file upload failed.`).then((r) => {
            })
        }
    }
    handleUpload = (f, onSuccess) => {
        ExcelRenderer(f, (err, resp) => {
            if (err) {
                message.error(err).then((r) => {
                })
            } else {
                let rows = resp.rows.filter((v) => {
                    return v.length !== 0
                })
                const titles = rows[0]
                const columns = titles.map((item, idx) => {
                    return {
                        title: item,
                        dataIndex: idx,
                        key: idx,
                        render: (text, record, index) => (
                            <span
                                style={{
                                    display: 'block',
                                    overflow: 'hidden',
                                    whiteSpace: 'nowrap',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                {text}
              </span>
                        )
                    }
                })
                rows.shift()
                const data = rows.map((item, idx) => {
                    const obj = {}
                    for (let i = 0; i < item.length; i++) {
                        if (item[i]) obj[i] = String(item[i]).trim()
                    }
                    return obj
                })
                this.setState({
                    cols: columns,
                    dataSource: data,
                    rows: rows
                })
            }
            onSuccess()
        })
    }

    handleUpdate = () => {
        this.setState({
            progressVisible: false,
            loading: true
        })

        function checkIfTrue(true_str) {
            if (!true_str) return false
            true_str = true_str.toLowerCase()
            return true_str === 'true' || true_str === 'y' || true_str === 'yes'
        }

        function sanity_str(str) {
            if (!str) return str
            str = str.trim()
            str = str.toLowerCase()
            return str.replace(' ', '-')
        }

        let postTasks = []
        let artwork_ids = []
        let progressLayout = []

        this.state.rows.map((v) => {
            if (v.length === 0) return
            const i = 0
            let skuNum = ''
            let artworkName = ''
            let copy_num = ''
            let width = ''
            let height = ''
            let depth = ''
            let size_desc_str = ''
            let year = ''
            let style_type_str = ''
            let medium_type_str = ''
            let material_type_str = ''
            let content_info_str = ''
            let label_str = ''
            let is_sell = ''
            let price_type_str = ''
            let is_framed = ''
            let is_commission = ''
            let is_prints = ''
            let is_liscence = ''
            let extra_info_str = ''
            // let other_medium = ''
            // let other_subject = ''

            skuNum = v[i]
            artworkName = v[i + 1]
            copy_num = v[i + 2]
            width = v[i + 3]
            height = v[i + 4]
            depth = v[i + 5]
            size_desc_str = v[i + 6]
            year = v[i + 7]
            style_type_str = sanity_str(v[i + 8])
            medium_type_str = sanity_str(v[i + 9])
            material_type_str = v[i + 10]
            content_info_str = sanity_str(v[i + 11])
            label_str = v[i + 12]
            is_sell = v[i + 13]
            price_type_str = v[i + 14]
            is_framed = v[i + 15]
            is_commission = v[i + 16]
            is_prints = v[i + 17]
            is_liscence = v[i + 18]
            extra_info_str = v[i + 19]
            // other_medium = v[i + 20]
            // other_subject = v[i + 21]

            let used_type = []

            if (checkIfTrue(is_sell)) {
                used_type.push('original')
            }
            if (checkIfTrue(is_commission)) {
                used_type.push('commission')
            }
            if (checkIfTrue(is_prints)) {
                used_type.push('prints')
            }

            if (checkIfTrue(is_liscence)) {
                used_type.push('licensing')
            }

            if (checkIfTrue(is_framed)) {
                is_framed = true
            } else {
                is_framed = false
            }

            let isCreate = false
            if (!skuNum) {
                isCreate = true
            } else {
                artwork_ids.push(skuNum)
            }
            const artworkParam = {
                name: artworkName,
                year: year,
                s3_url: 's3_url',
                static_url: 'static_url',
                file_size: 0,
                used_type: used_type.length === 0 ? '' : used_type?.join(','),
                copy_num: copy_num !== '' ? copy_num : 0,

                label_str: label_str,
                medium_type_str: medium_type_str,
                material_type_str: material_type_str,
                size_type_str: height + ',' + width + ',' + depth,
                frame_size_h: height,
                frame_size_w: width,
                frame_size_d: depth,
                size_desc_str: size_desc_str,
                price_type_str: price_type_str,
                style_type_str: style_type_str,
                extra_info_str: extra_info_str,
                content_info_str: content_info_str
            }
            const user_created_date = moment(`${year}-${'01'}-${'01'}`, 'YYYY-MM-DD').format('YYYY-MM-DD')
            const artworkConfigParam = {
                is_visible_gallery: true,
                is_display_watermark: false,
                is_framed: is_framed,
                is_for_sale: checkIfTrue(is_sell),
                frame_size_h: height,
                frame_size_w: width,
                frame_size_d: depth,
                frame_desc: '',
                user_created_date
            }
            if (isCreate) {
                // postTasks.push(
                //     postArtworkAdmin({artist: name_id[0].id, ...artworkParam})
                //         .then(async (response) => {
                //             await postArtworkConfig({
                //                 artwork: response.data.id,
                //                 ...artworkConfigParam,
                //             });
                //         })
                //         .catch((error) => {
                //             HttpError(error)
                //         })
                // )
            } else {
                delete artworkParam['s3_url']
                delete artworkParam['static_url']
                const getError = (error) => {
                    if (!error) return 'Unknown Error'
                    if (error.response && error.response.data) return JSON.stringify(error.response.data)
                    if (error.message) return error.message.toString()
                    return error
                }
                postTasks.push(
                    patchArtwork(parseInt(skuNum), artworkParam)
                        .then(async (response) => {
                            await patchArtworkConfig(response.data.id, artworkConfigParam)
                            return (
                                <Row>
                                    <Col span={2}>
                                        <span># {response.data.id} </span>
                                    </Col>
                                    <Col span={22}>
                                        <Progress percent={100} size='small'/>
                                    </Col>
                                </Row>
                            )
                        })
                        .catch((error) => {
                            return (
                                <Row>
                                    <Col span={2}>
                                        <span># {parseInt(skuNum)} </span>
                                    </Col>
                                    <Col span={20}>
                                        <Progress status='exception' percent={100} size='small'/>
                                    </Col>
                                    <Col span={2}>
                                        <a target={'_blank'} href={getEditUrl(URL_EDIT_PIECES_ID, parseInt(skuNum))}
                                           rel='noreferrer'>
                                            View
                                        </a>
                                    </Col>
                                    <Col span={24}>
                                        <Alert
                                            message={'We get error: ' + getError(error) + ' . Contact us it@revart.co'}
                                            type='error'/>
                                    </Col>
                                </Row>
                            )
                        })
                )
            }
        })

        Promise.all(postTasks)
            .then((p) => {
                progressLayout.push(p)
                this.setState({
                    promiseResults: progressLayout,
                    loading: false,
                    totalPromiseNum: postTasks.length
                })
            })
            .catch((e) => {
                HttpError(e)
            })

        this.setState({
            promiseResults: progressLayout,
            progressVisible: true
        })
    }

    customRequestBulkUpload = (options) => {
        const {onError, onSuccess, file, onProgress} = options
        uploadImage(this.props.email, file, onSuccess, onError, onProgress)
    }

    customRequestArtworkSheet = (options) => {
        const {onSuccess, file} = options
        this.handleUpload(file, onSuccess)
    }

    componentDidMount() {
    }

    handlePreview(file) {
        const getBase64 = (file) =>
            new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.readAsDataURL(file)

                reader.onload = () => resolve(reader.result)

                reader.onerror = (error) => reject(error)
            })

        if (!file.url && !file.preview) {
            file.preview = getBase64(file.originFileObj)
        }

        this.setState({
            previewImage: file.url || file.preview,
            previewVisible: true,
            previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
        })
    }

    confirmUpdate(ins, state, props) {
        let promiseResults = []
        ins.setState({
            loading: true
        })
        state.fileList.forEach((element, index) => {
            let artworkParam = {
                name: element.name,
                s3_url: element.response.s3_url,
                static_url: element.response.static_url,
                year: -1,
                file_size: 'string',
                used_type: '',
                copy_num: 1,
                label_str: '',
                medium_type_str: '',
                material_type_str: '',
                size_type_str: '',
                size_desc_str: '',
                sell_type_str: '',
                price_type_str: '',
                style_type_str: '',
                extra_info_str: '',
                artwork_pieces_str: '',
                color_info_str: '',
                content_info_str: '',
                notes_str: ''
            }
            const user_created_date = moment().format('YYYY-MM-DD')
            let artworkConfigParam = {
                is_visible_gallery: true,
                is_display_watermark: true,
                is_framed: false,
                frame_size_h: 0,
                frame_size_w: 0,
                frame_size_d: 0,
                frame_desc: '',
                user_created_date,
                inventory_quantity: 1,
                inventory_prints_quantity: 50,
                prints_markup_percentage: 20
            }
            if (!is_admin_user(state)) {
                promiseResults.push(
                    postArtwork(artworkParam)
                        .then(async (response) => {
                            await postArtworkConfig({
                                artwork: response.data.id,
                                ...artworkConfigParam
                            })
                        })
                        .catch((error) => {
                            HttpError(error)
                        })
                )
            } else {
                promiseResults.push(
                    postArtworkAdmin({artist: state.artistId, ...artworkParam})
                        .then(async (response) => {
                            await postArtworkConfig({
                                artwork: response.data.id,
                                ...artworkConfigParam
                            })
                        })
                        .catch((error) => {
                            HttpError(error)
                        })
                )
            }
        })
        Promise.all(promiseResults)
            .then((p) => {
                ins.setState({
                    loading: false
                })
                message.info('Successfully Upload.').then((v) => {
                })
            })
            .catch((e) => {
                HttpError(e)
            })
    }

    handleArtistSelect = (v) => {
        const tmp = []
        v.map((v) => {
            tmp.push(v)
        })
        this.setState({
            selectNameId: tmp
        })
    }

    showProgressModal = () => {
        this.setState({progressVisible: true})
    }

    render() {
        function getUpdateButton(state, func) {
            if (state.updateBtnEnabled) {
                return (
                    <Button
                        block
                        icon={<FileSyncOutlined/>}
                        type='primary'
                        size='large'
                        onClick={() => {
                            func()
                        }}
                    >
                        Update Pieces
                    </Button>
                )
            } else {
                return (
                    <Button
                        disabled
                        icon={<FileSyncOutlined/>}
                        block
                        type='primary'
                        size='large'
                        onClick={() => {
                            func()
                        }}
                    >
                        Update Pieces
                    </Button>
                )
            }
        }

        function showResultLayout(instance) {
            return (
                <Modal
                    title='Artwork Pieces Update Progress'
                    centered
                    visible={instance.state.progressVisible}
                    onCancel={() => {
                        instance.setState({progressVisible: false})
                    }}
                    footer={null}
                    width={1000}
                >
                    <div style={{overflow: 'auto', height: 400}}>
                        <p>Update {instance.state.totalPromiseNum} artwork pieces</p>
                        <Spin size='large' style={{marginTop: 20}} spinning={instance.state.loading}>
                            {instance.state.promiseResults}
                        </Spin>
                    </div>
                </Modal>
            )
        }

        function layoutByView(inst, props, state) {
            const items = []
            let idx = 0
            state.fileList.forEach((element, index) => {
                if (element.status === 'done') {
                    idx += 1
                }
                items.push(
                    <Col xs={12} sm={8} md={6} key={index}>
                        <Card
                            style={{
                                marginBottom: '20px'
                            }}
                            cover={<img src={element.response && element.response.static_url}
                                        alt={element.response && element.response.static_url}/>}
                            loading={element.response === undefined}
                            actions={[]}
                        >
                            <Row justify='space-between' align='middle'>
                                <Meta title={<span style={{whiteSpace: 'pre-line'}}>{element.name}</span>}/>
                            </Row>
                        </Card>
                    </Col>
                )
            })
            let isUpdate = idx !== 0 && idx === state.fileList.length
            if (isUpdate !== state.confirmBtnEnabled) {
                inst.setState({
                    confirmBtnEnabled: isUpdate
                })
            }
            return (
                <Row justify='flex-start' gutter={{xs: 8, sm: 16, md: 24}} style={{marginTop: '16px'}}>
                    {items}
                </Row>
            )
        }

        function getConfirmButton(inst, state, props, func) {
            if (state.confirmBtnEnabled) {
                return (
                    <Button
                        block
                        icon={<FileSyncOutlined/>}
                        type='primary'
                        size='large'
                        onClick={() => {
                            func(inst, state, props)
                        }}
                    >
                        Confirm Upload
                    </Button>
                )
            } else {
                return (
                    <Button
                        disabled
                        icon={<FileSyncOutlined/>}
                        block
                        type='primary'
                        size='large'
                        onClick={() => {
                            func(inst, state, props)
                        }}
                    >
                        Confirm Upload
                    </Button>
                )
            }
        }

        return (
            <Spin size='large' spinning={this.state.loading}>
                <Title>
                    Bulk Upload and Update
                    <div
                        style={{marginLeft: 12, display: 'inline-block', cursor: 'pointer'}}
                        onClick={() => {
                            this.props.history.push({pathname: URL_FAQS})
                        }}
                    >
                        <QuestionCircleOutlined style={{marginBottom: '5', alignSelf: 'middle', fontSize: '18px'}}/>
                    </div>
                </Title>
                <Divider/>
                <Title level={4}> Step 1: Bulk Images Upload </Title>
                <Dragger
                    multiple={true}
                    style={{marginTop: 12}}
                    listType='picture'
                    fileList={this.state.fileList}
                    onPreview={this.handlePreview}
                    customRequest={this.customRequestBulkUpload}
                    maxCount={20}
                    onChange={({fileList: newFileList}) => this.setState({fileList: newFileList})}
                >
                    <p className='ant-upload-drag-icon'>
                        <InboxOutlined/>
                    </p>
                    <p className='ant-upload-text'>Upload Individual Images (maximum: 20)</p>
                    <p className='ant-upload-hint'>Click or drag images to this area</p>
                    <br/>
                </Dragger>
                <Divider/>
                <Dragger
                    fileList={this.state.fileList}
                    onPreview={this.handlePreview}
                    customRequest={this.customRequestBulkUpload}
                    maxCount={20}
                    onChange={({fileList: newFileList}) => this.setState({fileList: newFileList})}
                    directory
                >
                    <p className='ant-upload-drag-icon'>
                        <InboxOutlined/>
                    </p>
                    <p className='ant-upload-text'>Upload Folder</p>
                    <p className='ant-upload-hint'>Put maximum 20 images in a folder and click or drag folder to this
                        area</p>
                </Dragger>
                <Divider/>
                <Row align='middle' gutter={{xs: 8, sm: 16, md: 24}} style={{marginTop: 12}}>
                    <Col>
                        <Title level={4} style={{marginBottom: 0}}>
                            Pieces ({this.state.fileList.length})
                        </Title>
                    </Col>
                </Row>
                {layoutByView(this, this.props, this.state)}
                <Row>
                    <Col span={5}>{getConfirmButton(this, this.state, this.props, this.confirmUpdate)}</Col>
                </Row>
                <Divider/>
                <Title level={4}> Step 2: Artwork Sheet Upload</Title>
                <Divider orientation='left'>Info Sheets Template</Divider>
                <Button type={'link'} href={Sheets} target={'_blank'} icon={<FileTextFilled/>}>
                    Download the excel sheet template
                </Button>

                <Divider orientation='left'>Artwork Info Upload Panel</Divider>
                <Dragger maxCount={1} name='fileexcel' customRequest={this.customRequestArtworkSheet}
                         onChange={this.onChange}>
                    <p className='ant-upload-drag-icon'>
                        <InboxOutlined/>
                    </p>
                    <p className='ant-upload-text'>Click or drag Excel Artwork Sheet to this area to upload</p>
                </Dragger>

                <Table
                    scroll={{x: 1300}}
                    pagination={{
                        pageSize: 10
                    }}
                    columns={this.state.cols}
                    dataSource={this.state.dataSource}
                />

                {showResultLayout(this)}
                <Divider/>
                <Row>
                    <Col span={5}>{getUpdateButton(this.state, this.handleUpdate)}</Col>
                </Row>
                <Divider/>
                <Title
                    level={4}
                    underline='true'
                    onClick={() => {
                        this.props.history.push(URL_PIECES)
                    }}
                >
                    Step 3: Check updates in Pieces (Click)
                </Title>
            </Spin>
        )
    }
}

export default withRouter(NewBulkUpload)
